import { css, cx } from "@emotion/css";
import { borderRadius, themeTokens, text } from "@octopusdeploy/design-system-tokens";
import { HeaderSecondary } from "../HeaderSecondary";
import { LinearProgress } from "../Progress/LinearProgress";
import { ErrorPanel, type ErrorInfo } from "./ErrorPanel";
interface Level2InnerPageLoadingProps {
    loadingTitle: string;
    errors?: ErrorInfo[];
    isFullWidth?: boolean;
}
export function Level2InnerPageLoading({ loadingTitle, errors, isFullWidth }: Level2InnerPageLoadingProps) {
    return (<div className={cx(pageContentStyles.container, isFullWidth ? undefined : pageContentStyles.constrained)}>
            <LinearProgress variant={"indeterminate"} show={errors === undefined || errors.length === 0}/>
            <HeaderSecondary title={loadingTitle ?? "..."}/>
            {errors?.map((error, index) => (<ErrorPanel key={index} error={error}/>))}
        </div>);
}
const pageContentStyles = {
    container: css({
        display: "flex",
        flexDirection: "column",
        borderRadius: borderRadius.small,
        border: `1px solid ${themeTokens.color.border.primary}`,
        minHeight: 640,
        marginLeft: "auto",
        marginRight: "auto",
        font: text.body.regular.medium,
    }),
    constrained: css({
        maxWidth: 1280,
    }),
};
